export default __webpack_public_path__ + "static/media/explorer.16b9d96f.svg";